import { useLocations } from "@/hooks/useData";
import { useI18n } from "@/i18n/I18nProvider";

const LEVELS = ["governorate", "district", "city", "neighborhood"];
const KEYS = { governorate: "governorate_id", district: "district_id", city: "city_id", neighborhood: "neighborhood_id" };

function LevelSelect({ level, parentId, value, onChange, error, required, prefix, emptyLabel }) {
  const { t, nm } = useI18n();
  const enabled = level === "governorate" || !!parentId;
  const { items } = useLocations(level === "governorate" ? null : parentId, enabled);
  if (level !== "governorate" && level !== "district" && enabled && !items.length) return null;
  return (
    <div>
      <label className="bay-label">{t(`loc.${level}`)}{required && " *"}</label>
      <select data-testid={`${prefix}-${level}-select`} className={`bay-input ${error ? "border-red-500" : ""}`}
        value={value || ""} disabled={!enabled} onChange={(e) => onChange(e.target.value || null, items.find((i) => i.id === e.target.value))}>
        <option value="">{emptyLabel || t("common.select")}</option>
        {items.map((i) => <option key={i.id} value={i.id}>{nm(i)}</option>)}
      </select>
      {error && <p className="mt-1 text-xs text-red-600" data-testid={`${prefix}-${level}-error`}>{error}</p>}
    </div>
  );
}

export default function LocationSelects({ value, onChange, levels = 4, errors = {}, requiredLevels = [], prefix = "loc", anyLabel = false, onPick }) {
  const { t } = useI18n();
  const set = (idx) => (id, item) => {
    const next = { ...value };
    LEVELS.forEach((lvl, i) => { if (i === idx) next[KEYS[lvl]] = id; if (i > idx) next[KEYS[lvl]] = null; });
    onChange(next);
    if (item && onPick) onPick(item);
  };
  return LEVELS.slice(0, levels).map((lvl, i) => (
    <LevelSelect key={lvl} level={lvl} prefix={prefix} value={value[KEYS[lvl]]}
      parentId={i === 0 ? null : value[KEYS[LEVELS[i - 1]]]} onChange={set(i)} error={errors[lvl]}
      required={requiredLevels.includes(lvl)}
      emptyLabel={anyLabel ? (i === 0 ? t("loc.allGovernorates") : i === 1 ? t("loc.allDistricts") : t("common.all")) : undefined} />
  ));
}
